// generated by the plop

import { DebtFilterModel, DebtModel } from 'shared';
import { PaginateQuery, PaginatorModel } from 'symbols';

export class UpdatedDebtByWS {
  static type = '[debtList] UpdatedDebtByWS';

  constructor(public debt: DebtModel) {
  }
}

export class CreatedDebtByWS {
  static type = '[debtList] CreatedDebtByWS';

  constructor(public debt: DebtModel) {
  }
}

export class GetDebtList {
  static type = '[debtList] GetDebtList';

  constructor(public lazy: boolean, public filter?: PaginateQuery<DebtFilterModel>) {
  }
}

export class GetDebtListSuccess {
  static type = '[debtList] GetDebtListSuccess';

  constructor(public debtList: PaginatorModel<DebtModel> & { debtsAmount: number }, public lazy: boolean) {
  }
}

export class GetDebtListError {
  static type = '[debtList] GetDebtListError';

  constructor(public error: any) {
  }
}


export class ClearScrollPositionDebtList {
  static type = '[DebtsList] ClearScrollPositionDebtList';
}

export class UpdateScrollPositionDebtList {
  static type = '[DebtsList] UpdateScrollPositionDebtList';

  constructor(public position: number) {
  }
}

export class SetLastOpenedDebtId {
  static type = '[DebtsList] SetLastOpenedDebtId';

  constructor(public debtId: string) {
  }
}
